<template>
  <div>
    <div :id="id" class="tree mb-3" style="min-width: auto !important">
      <div v-for="question in questions" :key="question.id" class="section">
        <div class="question-container my-1" @dragover="(e) => dragOver(e, question.id)">
          <div class="question d-flex flex-column bg-white border rounded w-100">
            <div
              class="d-flex align-items-center justify-content-between py-2 px-3"
              draggable
              @dragstart="(e) => dragStart(e, question.id)"
              @dragend="(e) => dragEnd(e)"
            >
              <div class="d-flex flex-column">
                <div
                  class="question-title"
                  style="width: fit-content"
                  v-b-modal="`editTestQuestion${testId}`"
                  @click="editQuestion(question)"
                >
                  {{ question.value }}
                </div>
                <span class="text-muted" style="font-size: 12px">{{ answerTypeNames[question.type_id] }}</span>
              </div>
              <b-icon-x class="question-remove" scale="1.5" @click="deleteQuestion(question.id)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-button variant="primary" size="sm" @click="() => addQuestion()" style="width: fit-content"
      >Добавить вопрос</b-button
    >

    <b-modal
      v-if="editedQuestion.id"
      :id="`editTestQuestion${testId}`"
      centered
      :header-close-content="null"
      hide-footer
      title="Редактирование вопроса"
    >
      <div class="d-flex flex-column">
        <b-form-input
          v-model="editedQuestion.value"
          placeholder="Введите вопрос"
          class="mb-1"
          @change="onQuestionEdit('value')"
        />
        <b-form-select v-model="editedQuestion.type_id" class="mb-4" @change="onQuestionEdit('type_id')">
          <b-form-select-option :value="answerTypes.one_correct">{{
            answerTypeNames[answerTypes.one_correct]
          }}</b-form-select-option>
          <b-form-select-option :value="answerTypes.multiple_correct">{{
            answerTypeNames[answerTypes.multiple_correct]
          }}</b-form-select-option>
          <b-form-select-option :value="answerTypes.open">{{ answerTypeNames[answerTypes.open] }}</b-form-select-option>
          <b-form-select-option :value="answerTypes.open_with_moderation">{{
            answerTypeNames[answerTypes.open_with_moderation]
          }}</b-form-select-option>
        </b-form-select>

        <lesson-test-question-answers :isManage="isManage" :question="editedQuestion" :reloadAnswers="reloadAnswers" />
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/custom/colors.scss";
.question-collapse,
.question-remove {
  stroke: #999;
  cursor: pointer;
  &:hover {
    stroke: #666 !important;
  }
  &:active {
    stroke: #333 !important;
  }
}
.tree {
  display: flex;
  flex-direction: column;
  .section {
    display: flex;
    flex-direction: column;
    position: relative;
    .question-container {
      .question {
        .question-title {
          cursor: pointer;
          &:hover {
            color: $primary;
          }
        }
      }
      [draggable] {
        cursor: grab;
      }
    }
  }
}

#drag-placeholder {
  .line {
    margin-left: -1px;
    margin-right: -1px;
    height: 2px;
    background-color: $primary;
  }
  .arrow {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    &.left {
      border-right-color: #5867dd;
      border-left: none;
    }
    &.right {
      border-left-color: #5867dd;
      border-right: none;
    }
  }
}
</style>

<script>
import {
  BIconX,
  BIconChevronLeft,
  BIconCardText,
  BIconFileEarmarkText,
  BIconPlayBtn,
  BIconImage,
  BIconChevronDown,
} from "bootstrap-vue";
import Api from "shared/service/api/api";
import LessonTestQuestionAnswers from "shared/widgets/lesson/test/LessonTestQuestionAnswers.vue";

export default {
  name: "LessonQuestionTree",
  props: {
    testId: {
      type: Number,
      required: true,
    },
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BIconX,
    BIconChevronLeft,
    BIconCardText,
    BIconFileEarmarkText,
    BIconPlayBtn,
    BIconImage,
    BIconChevronDown,
    LessonTestQuestionAnswers,
  },
  computed: {
    lessonId() {
      return Number(this.$route.params.lessonId);
    },
    placement: () => ({
      beforeQuestion: -1,
      afterQuestion: 1,
    }),
    answerTypes() {
      return {
        one_correct: 1,
        multiple_correct: 2,
        open: 3,
        open_with_moderation: 4,
      };
    },
    answerTypeNames() {
      return {
        1: "Один правильный ответ",
        2: "Несколько правильных ответов",
        3: "Открытый вопрос с автопроверкой",
        4: "Открытый вопрос с модерацией",
      };
    },
    apiNamespace() {
      return this.isManage ? Api.admin.course.lesson.test.question : Api.course.lesson.test.question;
    },
  },
  data() {
    return {
      id: "LessonQuestionTree_" + Date.now(),
      draggedId: null,
      draggedOver: {
        questionId: null,
        placement: null,
      },
      questions: [],
      editedQuestion: {},
      reloadAnswers: 0, // даёт сигналам на обновление ответам при изменении типа вопроса
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.apiNamespace
        .all(this.lessonId, this.testId)
        .then((response) => {
          this.questions = response.data;
          this.$emit("questionCountChange", this.questions.length);
        })
        .catch(() => {
          this.$alert.error("Ошибка загрузки данных теста");
        });
    },
    /* DRAG */
    dragStart(e, questionId) {
      e.target.style.opacity = 0.5;
      this.draggedId = questionId;
      this.draggedOver = {
        questionId: questionId,
        placement: this.placement.beforeQuestion,
      };
    },
    dragEnd({ target }) {
      target.style.opacity = 1;
      this.removeDragPlaceholder();

      if (this.draggedId === this.draggedOver.questionId) {
        this.resetDragData();
        return;
      }

      let draggedQuestion = this.questions.find((b) => b.id === this.draggedId);
      const draggedOverQuestion = this.questions.find((b) => b.id === this.draggedOver.questionId);

      try {
        const weightDiff = 5;
        const newWeight = draggedOverQuestion.weight + this.draggedOver.placement * weightDiff;

        // prevent putting an element right before and after itself
        if (Math.abs(draggedQuestion.weight - newWeight) === weightDiff) {
          throw new Error();
        }

        draggedQuestion.weight = newWeight;
        // show user that the question has been moved
        // since array.find() returns a reference, we don't need to make any changes in the array, only sort it
        this.questions.sort((left, right) => left.weight - right.weight);
        this.saveQuestion({
          id: draggedQuestion.id,
          weight: newWeight,
        });
      } catch {}

      this.resetDragData();
    },
    resetDragData() {
      this.draggedId = null;
      this.draggedOver = {
        questionId: null,
        placement: null,
      };
    },
    dragOver(e, questionId) {
      if (!this.draggedId) {
        return;
      }

      // calculate where mouse is relative to the dragged over element
      const questionContainer = e.target.closest(".question-container");
      const clientRect = questionContainer.getBoundingClientRect();
      const percentage = (e.clientY - clientRect.top) / clientRect.height;
      const placement = Math.sign(percentage - 0.5);
      this.draggedOver = {
        questionId: questionId,
        placement: placement,
      };

      this.removeDragPlaceholder();
      const dragPlaceholder = this.createDragPlaceholder();
      dragPlaceholder.setAttribute("style", `${placement === this.placement.afterQuestion ? "bottom" : "top"}: -5px`);
      questionContainer.insertAdjacentElement(
        placement === this.placement.afterQuestion ? "afterend" : "beforebegin",
        dragPlaceholder
      );
    },
    createDragPlaceholder() {
      const newPlaceholder = Object.assign(document.createElement("div"), {
        id: "drag-placeholder",
        classList: "w-100 d-flex align-items-center justify-content-center position-absolute",
      });
      newPlaceholder.append(
        Object.assign(document.createElement("div"), {
          classList: "arrow right",
        }),
        Object.assign(document.createElement("div"), {
          classList: "line w-100 border-0",
        }),
        Object.assign(document.createElement("div"), {
          classList: "arrow left",
        })
      );
      return newPlaceholder;
    },
    removeDragPlaceholder() {
      const previousPlaceholder = document.getElementById("drag-placeholder");
      previousPlaceholder && previousPlaceholder.remove();
    },
    /* COMMON */
    deleteQuestion(questionId) {
      this.apiNamespace.delete(this.lessonId, questionId).then((response) => {
        response.success ? this.load() : this.$alert.error("Ошибка удаления вопроса");
      });
    },
    addQuestion() {
      this.apiNamespace
        .create(this.lessonId, this.testId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.load();
        })
        .catch((e) => this.$alert.error("Ошибка создания вопроса<br>" + e.message));
    },
    editQuestion(question) {
      this.editedQuestion = question;
    },
    saveQuestion(question, reload = true) {
      return this.apiNamespace
        .save(this.lessonId, question)
        .then((response) => {
          !response.success && this.$alert.error("Ошибка сохранения вопроса");
        })
        .finally(() => {
          reload && this.load();
        });
    },
    onQuestionEdit(fieldName) {
      const fieldValue = this.editedQuestion[fieldName];
      if (["value"].includes(fieldName) && !fieldValue) {
        return;
      }

      const isTypeIdChanged = fieldName === "type_id";

      this.saveQuestion(
        {
          id: this.editedQuestion.id,
          [fieldName]: fieldValue,
        },
        false
      ).then(() => {
        isTypeIdChanged && this.reloadAnswers++;
      });
    },
  },
};
</script>
